import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import moment from 'moment';
import { saveAs } from "file-saver";
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';

export default class StoreStockReport extends Component {
    constructor(props) {
        super(props)
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            itemObject: {
                idProduct: 0,
                productList: [],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
            },
        }
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                // this.getAllDropdownForStockMaster();
                // this.getMasterExpenseAccGroupCount();
            });
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        // this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Account Group",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let data = response.responseItem.responseContent;
                if (data.length > 0) {

                    const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                        field: key.includes(".") ? key.replace(/\./g, "_") : key,
                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                        minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                        flex: 1,
                        filter: true,
                        floatingFilter: true,
                        hide: ["idAccountGroup"].includes(key) ? true : false,
                        width: this.getPinnedWidth(key),
                        valueGetter: (params) => params.data[key],
                        // valueFormatter: key.includes("date") || key.includes("invoiceDate")
                        //   ? (params) => {
                        //     if (!params.value) return "";
                        //     return moment(params.value).format("DD-MM-YYYY");
                        //   }
                        //   : undefined,
                        //pinned: ["idBank", "sR.No", "employeeName"].includes(key) ? "left" : null,
                    }));
                    //const priorityColumn = "bankName"; // Replace with the actual column name
                    //const pinnedColumns = dynamicColDefs.filter(col => col.pinned === "left");
                    //const priorityColDef = dynamicColDefs.find(col => col.field === priorityColumn);
                    //const otherColumns = dynamicColDefs.filter(col => col.field !== priorityColumn && !col.pinned);

                    // const updatedColDefs = [
                    //   ...pinnedColumns,
                    //   ...(priorityColDef ? [priorityColDef] : []),
                    //   ...otherColumns,
                    // ];
                    var colName = dynamicColDefs[0].field;
                    let id = data ? data[0][colName] : 0;
                    this.setState({
                        rowData: data,
                        colDefs: dynamicColDefs, //updatedColDefs,
                        caption: "Account Group",
                        colName: colName
                    }, () => {
                        //this.procSelectAllRecord2GridviewSP(id, "Advance Withdraw");
                        //this.getAllDropdownForEmployeeMaster();
                    });
                } else {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay();
                        this.gridApi.showNoRowsOverlay();
                    }
                }
            }
        });
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[125px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 237px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] pt-[0]">Store stock report</h1>
                                </div>

                                <AgGridReact
                                    rowData={this.state.rowData}
                                    columnDefs={this.state.colDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate={'<span>No Rows To Show</span>'}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
